export default __webpack_public_path__ + "static/media/dj.66797e3c.svg";